/**
 * Module-level store for the active SignalR connection ID.
 * Used by the API client to send X-SignalR-Connection-Id headers
 * so the server can exclude the caller from notifications.
 */

let connectionId: string | null = null

export function setSignalRConnectionId(id: string | null): void {
  connectionId = id
}

export function getSignalRConnectionId(): string | null {
  return connectionId
}
